// App.js
// This is the ROOT of the app. It does two things:
//   1. Wraps everything in <BrowserRouter> so React Router can work
//   2. Defines which URL paths map to which page components
//
// React Router v6 uses <Routes> + <Route> instead of the old <Switch>

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages — each file is one "screen" of the site
import Home         from './pages/Home';
import About        from './pages/About';
import Process      from './pages/Process';
import Services     from './pages/Services';
import Gallery      from './pages/Gallery';
import Testimonials from './pages/Testimonials';
import Contact      from './pages/Contact';

export default function App() {
  return (
    <BrowserRouter>
      {/* Navbar sits outside <Routes> so it always shows on every page */}
      <Navbar />

      {/* Routes decides which page component to render based on the URL */}
      <Routes>
        <Route path="/"             element={<Home />} />
        <Route path="/about"        element={<About />} />
        <Route path="/process"      element={<Process />} />
        <Route path="/services"     element={<Services />} />
        <Route path="/gallery"      element={<Gallery />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact"      element={<Contact />} />
      </Routes>

      {/* Footer also shows on every page */}
      <Footer />
    </BrowserRouter>
  );
}
